module.exports = __webpack_public_path__ + "img/magento-modules-customization_medium@2x.1c290881.webp";